import React, { useState } from "react";
import Name from "../components/Name";
import ProfilePIc from "../components/ProfilePIc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faUser,
  faSheetPlastic,
  faDiagramProject,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import PlaceHolder from "../components/PlaceHolder";
import CircleIconHolder from "../components/CircleIconHolder";
import { useMyContext } from "../store/MyContext";

function NavBarSides(props) {
  const { updateStateOnClick } = useMyContext();
  const [homeState, setHomeState] = useState(false);
  const [aboutState, setAboutState] = useState(false);
  const [resumeState, setResumeState] = useState(false);
  const [projectState, setProjectState] = useState(false);
  const [contactState, setContactState] = useState(false);
  const handleClickHome = () => {
    updateStateOnClick(1);
  };
  const handleClickAbout = () => {
    updateStateOnClick(2);
  };
  const handleClickResume = () => {
    updateStateOnClick(3);
  };
  const handleClickProject = () => {
    updateStateOnClick(4);
  };
  const handleClickContact = () => {
    updateStateOnClick(5);
  };
  const handleMouseOver = () => {
    setHomeState(true);
  };
  const handleMouseOverAbout = () => {
    setAboutState(true);
  };
  const handleMouseOverResume = () => {
    setResumeState(true);
  };
  const handleMouseOverProject = () => {
    setProjectState(true);
  };
  const handleMouseOverContact = () => {
    setContactState(true);
  };
  const handleMouseLeave = () => {
    setHomeState(false);
  };
  const handleMouseLeaveAbout = () => {
    setAboutState(false);
  };
  const handleMouseLeaveResume = () => {
    setResumeState(false);
  };
  const handleMouseLeaveProject = () => {
    setProjectState(false);
  };
  const handleMouseLeaveContact = () => {
    setContactState(false);
  };
  return (
    <div style={{ width: "200px" }}>
      <ProfilePIc />
      <Name
        text={"Cheng Zihao"}
        styles={{
          fontFamily: "Libre Franklin, sans-serif",
        }}
      />
      <CircleIconHolder />
      <PlaceHolder
        styles={{
          marginTop: "40px",
          backgroundColor: homeState ? "#808080" : "black",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onclick={handleClickHome}
        mouseOver={handleMouseOver}
        mouseLeave={handleMouseLeave}
      >
        <FontAwesomeIcon icon={faHouse} color="white" />
        <Name
          text={"Home"}
          styles={{ margin: 0, fontSize: "18px", marginLeft: "15px" }}
        />
      </PlaceHolder>
      <PlaceHolder
        onclick={handleClickAbout}
        styles={{
          backgroundColor: aboutState ? "#808080" : "black",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        mouseOver={handleMouseOverAbout}
        mouseLeave={handleMouseLeaveAbout}
      >
        <FontAwesomeIcon icon={faUser} color="white" />
        <Name
          text={"About"}
          styles={{ margin: 0, fontSize: "18px", marginLeft: "15px" }}
        />
      </PlaceHolder>
      <PlaceHolder
        onclick={handleClickResume}
        styles={{
          backgroundColor: resumeState ? "#808080" : "black",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        mouseOver={handleMouseOverResume}
        mouseLeave={handleMouseLeaveResume}
      >
        <FontAwesomeIcon icon={faSheetPlastic} color="white" />
        <Name
          text={"Resume"}
          styles={{ margin: 0, fontSize: "18px", marginLeft: "15px" }}
        />
      </PlaceHolder>
      <PlaceHolder
        onclick={handleClickProject}
        styles={{
          backgroundColor: projectState ? "#808080" : "black",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        mouseOver={handleMouseOverProject}
        mouseLeave={handleMouseLeaveProject}
      >
        <FontAwesomeIcon icon={faDiagramProject} color="white" />
        <Name
          text={"Projects"}
          styles={{ margin: 0, fontSize: "18px", marginLeft: "15px" }}
        />
      </PlaceHolder>
      <PlaceHolder
        onclick={handleClickContact}
        styles={{
          backgroundColor: contactState ? "#808080" : "black",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        mouseOver={handleMouseOverContact}
        mouseLeave={handleMouseLeaveContact}
      >
        <FontAwesomeIcon icon={faPhone} color="white" />
        <Name
          text={"Contact"}
          styles={{ margin: 0, fontSize: "18px", marginLeft: "15px" }}
        />
      </PlaceHolder>
      <PlaceHolder
        styles={{
          position: "absolute",
          bottom: "0",
          marginBottom: "10px",
          width: "200px",
          paddingLeft: "0",
          justifyContent: "center",
          opacity: 1,
        }}
      >
        <div style={{ color: "white", opacity: "0.3" }}>@ Cheng Zihao</div>
      </PlaceHolder>
    </div>
  );
}
export default NavBarSides;
